module.exports = __webpack_public_path__ + "static/media/iOS-otp.023e0848.png";